import moment from 'moment';
import { DATE_SHORTCUTS } from '@utils/constants';

const converter = Object.create(null);
converter[DATE_SHORTCUTS.last6Hours] = [24, 'hours'];
converter[DATE_SHORTCUTS.past24Hours] = [24, 'hours'];
converter[DATE_SHORTCUTS.today] = [1, 'day'];
converter[DATE_SHORTCUTS.yesterday] = [1, 'day'];
converter[DATE_SHORTCUTS.lastWeek] = [1, 'week'];
converter[DATE_SHORTCUTS.thisMonth] = [1, 'month'];
// this causes misalignment between months of 31 and 30 for DoD
// converter[DATE_SHORTCUTS.lastMonth] = [1, 'month'];
converter[DATE_SHORTCUTS.past7Days] = [7, 'days'];
converter[DATE_SHORTCUTS.past30Days] = [30, 'days'];
converter[DATE_SHORTCUTS.past90Days] = [90, 'days'];

function calcComparisonInterval(interval, durationAllowed = 13) {
  const { shortcut } = interval;
  const { from, to } = interval;

  if (converter[shortcut]) {
    const [diff, unit] = converter[shortcut];
    const comparisonFrom = moment(from).subtract(diff, unit);
    const comparisonTo = moment(to).subtract(diff, unit);

    if (moment().diff(comparisonFrom, 'months') > durationAllowed) {
      return {};
    }
    return {
      from: comparisonFrom,
      to: comparisonTo,
    };
  }

  const diff = moment(to).diff(moment(from), 'days') + 1;
  const comparisonFrom = moment(from).subtract(diff, 'days');
  const comparisonTo = moment(to).subtract(diff, 'days');

  if (comparisonFrom.isBefore(moment().subtract(durationAllowed, 'months'), 'day')) {
    return {};
  }
  return {
    from: comparisonFrom,
    to: comparisonTo,
  };
}

const getComparisonDisabledDate =
  (interval, durationAllowed = 13) =>
  (current) => {
    const { from, to } = interval;
    const diff = moment(to).diff(moment(from), 'days');

    const now = moment();
    return (
      current.isAfter(now.subtract(diff, 'days'), 'day') ||
      current.isBefore(moment().subtract(durationAllowed, 'months'), 'day')
    );
  };

const isValidInterval = (interval, durationAllowed = 13) => {
  const { from } = interval;
  const start = moment(from);
  return start.isAfter(moment().subtract(durationAllowed, 'months'), 'day');
};

/* eslint-disable import/prefer-default-export */
export { calcComparisonInterval, getComparisonDisabledDate, isValidInterval };
